export const apiUrl = process.env.REACT_APP_THETREEP_API_URL;
export const ApiKeyValue = process.env.REACT_APP_THETREEP_API_KEY;
export const apiHeaders = {
  "Content-Type": "application/json",
  "api-key": ApiKeyValue,
};
export const billingURL = process.env.REACT_APP_BILLING_API_URL;
